import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ArrowRight, Sparkles } from 'lucide-react';

const SLIDES = [
  {
    id: 1,
    title: 'Nâng Tầm Phong Cách Cùng JapanICHIBA',
    subtitle: 'Bộ Sưu Tập Mới 2026',
    description: 'Khám phá các dòng sản phẩm thời trang & công nghệ độc bản được thiết kế riêng cho phong cách sống hiện đại.',
    buttonText: 'Khám Phá Ngay',
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1600&q=80',
    badge: 'Mẫu Mới Ra Mắt'
  },
  {
    id: 2,
    title: 'Thiết Bị Âm Thanh Độc Bản Premium',
    subtitle: 'Trải Nghiệm Đỉnh Cao',
    description: 'Công nghệ chống ồn chủ động cùng thiết kế công xưởng xa xỉ cho âm thanh chân thực từng chi tiết.',
    buttonText: 'Mua Ngay',
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1600&q=80',
    badge: 'Giảm 10% Mã: JapanICHIBA10'
  },
  {
    id: 3,
    title: 'Thời Trang Len Wool Thượng Hạng',
    subtitle: 'Ấm Áp & Sang Trọng',
    description: 'Chất liệu len nhập khẩu cao cấp giữ ấm hoàn hảo, cắt may tinh tế theo chuẩn thời trang quốc tế.',
    buttonText: 'Xem Bộ Sưu Tập',
    image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1600&q=80',
    badge: 'Số Lượng Có Hạn'
  }
];

export default function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Tự động chuyển slide sau mỗi 5 giây
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === SLIDES.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === SLIDES.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? SLIDES.length - 1 : prev - 1));
  };

  return (
    <section className="relative bg-slate-950 text-white overflow-hidden">
      {/* Slides Wrapper */}
      <div
        className="flex transition-transform duration-700 ease-out h-[480px] sm:h-[540px]"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {SLIDES.map((slide) => (
          <div key={slide.id} className="w-full shrink-0 relative h-full flex items-center">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 z-0">
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover opacity-40"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/80 to-transparent" />
            </div>

            {/* Slide Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
              <div className="max-w-xl space-y-4">
                <span className="inline-flex items-center space-x-1.5 text-xs font-bold uppercase tracking-widest text-indigo-400 bg-indigo-950/80 px-3 py-1 rounded-full border border-indigo-800">
                  <Sparkles className="w-3.5 h-3.5" />
                  <span>{slide.badge}</span>
                </span>

                <h1 className="text-3xl sm:text-5xl font-extrabold font-serif leading-tight text-white tracking-tight">
                  {slide.title}
                </h1>

                <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">
                  {slide.description}
                </p>

                <div className="pt-2">
                  <a
                    href="#products-section"
                    className="inline-flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold px-6 py-3.5 rounded-xl text-xs transition shadow-lg shadow-indigo-600/30"
                  >
                    <span>{slide.buttonText}</span>
                    <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 p-3 rounded-full bg-white/10 hover:bg-white/20 text-white backdrop-blur-md transition border border-white/10"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 p-3 rounded-full bg-white/10 hover:bg-white/20 text-white backdrop-blur-md transition border border-white/10"
      >
        <ChevronRight className="w-5 h-5" />
      </button>

      {/* Navigation Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex space-x-2">
        {SLIDES.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-2 rounded-full transition-all duration-300 ${
              currentSlide === index ? 'w-8 bg-indigo-500' : 'w-2 bg-white/40 hover:bg-white/70'
            }`}
          />
        ))}
      </div>
    </section>
  );
}